var ___EXPOSE_LOADER_IMPORT___ = require("-!../node_modules/awesome-typescript-loader/dist/entry.js??ruleSet[1].rules[2].use[0]!./index.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["Components"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["Components"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
